import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getColorFilterConfig } from '../filters/color';
import { BuilderSections } from '../../util/builder';

const thesakSizes = [
  'One Size',

  '1Y',
  '2Y',
  '3Y',
  '4Y',
  '5Y',

  'S/M',
  'L/XL',

  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
];

export const thesakShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: thesakSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.AboutPageHeroContent]: '1b425f7dec6a43c3ab90a2f2be5b565d',
      [BuilderSections.LandingPageInfoContent]: '75b9db74a62849e992ac41101c8ea695',
      [BuilderSections.SubscribeFormFooterContent]: '01321469b9944d1d9fb76c876d049567',
    },
  },
};
